module.exports = new __parcel__URL__("shop_machines_nine_lives_lounge.ce003ba6.png").toString();